<!-- ============================================================================
     CALENDAR TOOLBAR - Mobile-first design
     Desktop: Full toolbar with all controls visible
     Mobile: Compact header + FAB + bottom actions menu
     ============================================================================ -->

<!-- ==================== DESKTOP TOOLBAR ==================== -->
<div class="vc-calendar-toolbar vc-calendar-toolbar--desktop">
  <!-- Sección izquierda: solicitudes pendientes -->
  <div class="vc-calendar-toolbar__requests" *ngIf="!!!this.quickMode">
    <button
      *ngIf="hasPermission('APPOINTMENTS.UPDATE')"
      type="button"
      class="vc-calendar-toolbar__requests-chip"
      (click)="toggleRequestsPopover($event)"
    >
      <i class="fas fa-bell"></i>
      <span>{{ "APPOINTMENT.REQUESTS.PENDING" | translate }}</span>
      <strong>{{ pendingRequestsCount }}</strong>
    </button>
  </div>

  <!-- Sección de período y selector de fecha -->
  <div
    class="vc-calendar-toolbar__section vc-calendar-toolbar__section--period"
  >
    <app-selector-calendar-period
      [view]="this.view"
      [quickMode]="this.quickMode"
      [onAction]="this.onAction"
      [viewDate]="this.viewDate"
    ></app-selector-calendar-period>
  </div>

  <!-- Selector de vista -->
  <div class="vc-calendar-toolbar__section">
    <app-selector-calendar-mode
      [onAction]="this.onAction"
      [selected]="this.selectedView"
      #calendarModeSelector
    ></app-selector-calendar-mode>
  </div>

  <!-- Sección de acciones principales -->
  <div
    class="vc-calendar-toolbar__section vc-calendar-toolbar__section--actions"
    *ngIf="!!!this.quickMode"
  >
    <app-calendar-appointments-actions-buttons
      [calendar]="this.calendars"
      [onAction]="this.onAction"
      [viewDate]="this.viewDate"
    ></app-calendar-appointments-actions-buttons>
  </div>

  <!-- Sección derecha: Configuración -->
  <div
    class="vc-calendar-toolbar__section vc-calendar-toolbar__section--end"
    *ngIf="!!!this.quickMode"
  >
    <button
      class="vc-calendar-toolbar__btn vc-calendar-toolbar__btn--config"
      (click)="openSettings?.()"
      pTooltip="{{ 'CALENDAR.SETTINGS.TITLE' | translate }}"
      tooltipPosition="bottom"
    >
      <i class="fas fa-sliders-h"></i>
      <span class="vc-calendar-toolbar__btn-text">{{
        "CALENDAR.SETTINGS.TITLE" | translate
      }}</span>
    </button>
  </div>
</div>

<!-- ==================== MOBILE TOOLBAR ==================== -->
<div class="vc-mobile-toolbar">
  <!-- Header compacto: Nav + Fecha + Acciones -->
  <div class="vc-mobile-toolbar__header">
    <!-- Navegación de fecha: < Fecha > -->
    <div class="vc-mobile-toolbar__nav-group">
      <!-- Anterior -->
      <button
        class="vc-mobile-toolbar__nav-btn"
        (click)="navigatePrevious()"
        aria-label="Anterior"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Fecha actual (click para abrir picker) -->
      <button
        class="vc-mobile-toolbar__date"
        (click)="mobileDatePicker.toggle($event)"
        type="button"
      >
        <span class="vc-mobile-toolbar__date-text">{{ this.mobileTitle }}</span>
        <i class="fas fa-caret-down"></i>
      </button>

      <!-- Siguiente -->
      <button
        class="vc-mobile-toolbar__nav-btn"
        (click)="navigateNext()"
        aria-label="Siguiente"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Botones rápidos -->
    <div class="vc-mobile-toolbar__quick-actions">
      <!-- Hoy -->
      <button
        class="vc-mobile-toolbar__quick-btn"
        (click)="goToToday()"
        [class.vc-mobile-toolbar__quick-btn--active]="isToday"
      >
        {{ "COMMON.PERIODS.TODAY" | translate }}
      </button>

      <!-- Selector de vista compacto -->
      <div class="vc-mobile-toolbar__view-toggle">
        <button
          class="vc-mobile-toolbar__view-btn"
          [class.vc-mobile-toolbar__view-btn--active]="isMonthView"
          (click)="setView('month')"
        >
          <i class="fas fa-calendar-alt"></i>
        </button>
        <button
          class="vc-mobile-toolbar__view-btn"
          [class.vc-mobile-toolbar__view-btn--active]="isWeekView"
          (click)="setView('week')"
        >
          <i class="fas fa-calendar-week"></i>
        </button>
        <button
          class="vc-mobile-toolbar__view-btn"
          [class.vc-mobile-toolbar__view-btn--active]="isDayView"
          (click)="setView('day')"
        >
          <i class="fas fa-calendar-day"></i>
        </button>
      </div>

      <!-- Menú de acciones -->
      <button
        class="vc-mobile-toolbar__menu-btn"
        (click)="mobileMenu.toggle($event)"
        *ngIf="!!!this.quickMode"
        pTooltip="{{ 'COMMON.ACTIONS' | translate }}"
        tooltipPosition="bottom"
      >
        <i class="fas fa-ellipsis-v"></i>
      </button>

      <!-- Configuración (separado del menú) -->
      <button
        class="vc-mobile-toolbar__menu-btn"
        (click)="openSettings?.()"
        *ngIf="!!!this.quickMode"
        pTooltip="{{ 'CALENDAR.SETTINGS.TITLE' | translate }}"
        tooltipPosition="bottom"
      >
        <i class="fas fa-sliders-h"></i>
      </button>
    </div>
  </div>

  <!-- Date picker popup (móvil) -->
  <p-popover #mobileDatePicker styleClass="vc-mobile-date-picker">
    <div class="vc-mobile-date-picker__content">
      <p-datepicker
        [(ngModel)]="selectedMobileDate"
        [inline]="true"
        [showButtonBar]="true"
        (onSelect)="onMobileDateSelect($event); mobileDatePicker.hide()"
        (onTodayClick)="goToToday(); mobileDatePicker.hide()"
      ></p-datepicker>
    </div>
  </p-popover>

  <!-- Menú de acciones secundarias -->
  <p-popover #mobileMenu styleClass="vc-mobile-menu">
    <div class="vc-mobile-menu__content">
      <div class="vc-mobile-menu__header">
        <span>{{ "COMMON.ACTIONS" | translate }}</span>
      </div>

      <div class="vc-mobile-menu__list">
        <!-- Añadir cita -->
        <button
          class="vc-mobile-menu__item vc-mobile-menu__item--primary"
          (click)="addAppointmentMobile(); mobileMenu.hide()"
          *ngIf="hasPermission('APPOINTMENTS.CREATE')"
        >
          <i class="fas fa-calendar-plus"></i>
          <span>{{ "CALENDAR.ADD.APPOINTMENT" | translate }}</span>
        </button>

        <!-- Añadir nota -->
        <button
          class="vc-mobile-menu__item"
          (click)="addNoteMobile(); mobileMenu.hide()"
          *ngIf="hasPermission('CALENDAR_NOTES.CREATE')"
        >
          <i class="fas fa-sticky-note"></i>
          <span>{{ "CALENDAR.NOTES.ADD" | translate }}</span>
        </button>

        <button
          class="vc-mobile-menu__item"
          (click)="toggleRequestsPopover($event); mobileMenu.hide()"
          *ngIf="hasPermission('APPOINTMENTS.UPDATE')"
        >
          <i class="fas fa-bell"></i>
          <span>
            {{ "APPOINTMENT.REQUESTS.PENDING" | translate }} ({{ pendingRequestsCount }})
          </span>
        </button>
      </div>
    </div>
  </p-popover>
</div>

<p-popover #pendingRequestsPopover styleClass="vc-pending-requests-popover" appendTo="body">
  <div class="vc-pending-requests">
    <header class="vc-pending-requests__header">
      <h4>{{ "APPOINTMENT.REQUESTS.PENDING" | translate }}</h4>
      <span>{{ pendingRequestsCount }}</span>
    </header>

    @if (pendingRequestsLoading) {
      <p class="vc-pending-requests__state">{{ "COMMON.LOADING" | translate }}...</p>
    } @else if (!pendingRequests.length) {
      <p class="vc-pending-requests__state">
        {{ "APPOINTMENT.REQUESTS.EMPTY" | translate }}
      </p>
    } @else {
      <div class="vc-pending-requests__list">
        @for (appointment of pendingRequests; track appointment.id) {
          <article class="vc-pending-requests__item">
            <div class="vc-pending-requests__item-main">
              <strong>{{ getRequestTitle(appointment) }}</strong>
              <small>
                {{ appointment.start | date: "dd/MM/yyyy HH:mm" }}
              </small>
              <small *ngIf="getRequestTreatmentNames(appointment)">
                {{ getRequestTreatmentNames(appointment) }}
              </small>
            </div>
            <div class="vc-pending-requests__item-actions">
              <button
                pButton
                type="button"
                class="p-button-text p-button-sm"
                icon="fas fa-check"
                [label]="'COMMON.ACCEPT' | translate"
                (click)="approveRequest(appointment)"
              ></button>
              <button
                pButton
                type="button"
                class="p-button-text p-button-sm p-button-danger"
                icon="fas fa-times"
                [label]="'COMMON.REJECT' | translate"
                (click)="rejectRequest(appointment)"
              ></button>
            </div>
          </article>
        }
      </div>
    }
  </div>
</p-popover>

<app-reject-appointment-request-dialog
  [visible]="rejectDialogVisible"
  [loading]="rejectRequestWorking"
  [appointment]="rejectTarget"
  [calendars]="calendars || []"
  [customersId]="customers_id"
  [site]="site"
  (visibleChange)="rejectDialogVisible = $event; !rejectDialogVisible && closeRejectDialog()"
  (submitReject)="confirmRejectRequest($event)"
></app-reject-appointment-request-dialog>

<!-- ==================== FAB (Floating Action Button) - Mobile only ==================== -->
<button
  class="vc-fab"
  (click)="addAppointmentMobile()"
  *ngIf="!!!this.quickMode && hasPermission('APPOINTMENTS.CREATE')"
  [attr.aria-label]="'CALENDAR.ADD.APPOINTMENT' | translate"
>
  <i class="fas fa-plus"></i>
</button>
